import { useEffect, useState } from 'react';
import { useAPI } from '@/services';
import { UseQueryOptions } from 'react-query';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';

const useGetFundDetailSummerize = (
  reactQueryOptions?: UseQueryOptions<any>
) => {
  const fundCode = useGetFundCodeFromQuery();

  const [flatData, setFlatData] = useState('');
  const [fakeLoading, setFakeLoading] = useState(true);
  const { data, isFetched, isLoading } = useAPI(['ai', 'getSummarizeData'], {
    reactQueryOptions: {
      ...reactQueryOptions,
    },
    input: {
      pageType: 'FundDetail',
      targetCode: fundCode,
    },
  });

  useEffect(() => {
    if (data && data.items.length > 0 && isFetched) {
      const result = data.items
        .map((item) => `\n\n**${item.title}**\n\n${item.content}`)
        .join('\n');
      setFlatData(result);
    }
  }, [data, isFetched]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFakeLoading(false);
    }, 2000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return { data, flatData, isLoading: isLoading || fakeLoading };
};

export { useGetFundDetailSummerize };
